import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: (() => {
      const userInfo = localStorage.getItem('userInfo')
      if (!userInfo || userInfo === 'undefined') return {}
      try {
        return JSON.parse(userInfo)
      } catch (e) {
        return {}
      }
    })(),
    role: (() => {
      const role = localStorage.getItem('role')
      if (!role || role === 'undefined') return null
      try {
        return JSON.parse(role)
      } catch (e) {
        return null
      }
    })()
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo || {}
      if (userInfo) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
      } else {
        localStorage.removeItem('userInfo')
      }
    },
    CLEAR_TOKEN(state) {
      state.token = ''
      state.userInfo = {}
      state.role = null
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('role')
    },
    SET_ROLE(state, role) {
      state.role = role || null
      if (role) {
        localStorage.setItem('role', JSON.stringify(role))
      } else {
        localStorage.removeItem('role')
      }
    }
  },
  actions: {
    login({ commit }, data) {
      commit('SET_TOKEN', data.token)
      commit('SET_USER_INFO', data.userInfo)
      commit('SET_ROLE', data.role)
    },
    logout({ commit }) {
      commit('CLEAR_TOKEN')
    }
  },
  getters: {
    hasPermission: (state) => (permission) => {
      if (!state.role || !state.role.permissions) return false
      try {
        // permissions 可能是数组或 JSON 字符串
        let permissions = state.role.permissions
        if (typeof permissions === 'string') {
          // 清理控制字符（换行、回车、制表符等）
          permissions = permissions.replace(/[\x00-\x1F\x7F]/g, '')
          permissions = JSON.parse(permissions)
        }
        return Array.isArray(permissions) && permissions.includes(permission)
      } catch (e) {
        console.error('权限解析错误:', e, state.role.permissions)
        return false
      }
    },
    roleCode: (state) => {
      return state.role ? state.role.code : null
    }
  }
})
